import { Component, HostBinding, inject } from '@angular/core';
import { IFrameResizer } from '@tytapp/common';
import { ContentBlockViewComponent, ContentModule } from '@tytapp/content';
import { TextBlock } from './text-block';

@Component({
    selector: 'tyt-text-block',
    standalone: true,
    imports: [ ContentModule ],
    template: `
        <div
            class="cms-content"
            [attr.data-columns]="block.columns"
            [innerHTML]="block.body | formatToHtml: (block.format ?? 'markdown') | trustHtml"
            ></div>
    `,
    styles: [`
        :host[data-columns="2"] .cms-content { columns: 2; }
        :host[data-columns="3"] .cms-content { columns: 3; }
        :host[data-columns="4"] .cms-content { columns: 4; }
        :host[data-alignment="center"] .cms-content { text-align: center; }
        :host[data-alignment="right"] .cms-content { text-align: right; }
    `]
})
export class ViewComponent extends ContentBlockViewComponent<TextBlock> {
    private iframeResizer = inject(IFrameResizer);

    ngAfterViewInit() {
        super.ngAfterViewInit();
        this.iframeResizer.install('iframe');
    }

    @HostBinding('attr.data-alignment') get alignment() { return this.block.alignment; }
    @HostBinding('attr.data-columns') get columns() { return this.block.columns; }
}
